export default __webpack_public_path__ + "static/media/My-Order.a65370f1.jpg";